module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: ['pt-page', 'pt-page-1',
      _vm.meanList[0].clicked ? 'pt-page-current' : '',
      _vm.meanList[0].leave ? 'pt-page-moveToTop pt-page-current' : '',
      _vm.meanList[0].enter ? 'pt-page-scaleUp' : ''
    ],
    attrs: {
      "id": "mod-home"
    }
  }, [_c('div', {
    staticClass: "mod-bg-video covervid-wrapper loop",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_vm._m(0), _vm._v(" "), _c('video', {
    staticClass: "covervid-video",
    staticStyle: {
      "position": "absolute",
      "top": "50%",
      "left": "50%",
      "transform": "translate(-50%, -50%)",
      "height": "auto",
      "width": "1320px"
    },
    attrs: {
      "id": "loopVideo",
      "loop": "'true'",
      "muted": ""
    },
    domProps: {
      "muted": true
    },
    on: {
      "canplay": _vm.canplay
    }
  }, [_c('source', {
    attrs: {
      "src": "../media/160329_Rimowa_Topas_Loop_v2_2000.mp4",
      "type": "video/mp4"
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    class: ['mod-bg-video', 'covervid-wrapper', 'full', _vm.currentBoolean.isFullPlay ? 'anim' : 'animout'],
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('span', {
    staticClass: "close",
    on: {
      "click": _vm.closeFullPlay
    }
  }, [_c('span'), _c('span')]), _vm._v(" "), _c('video', {
    staticClass: "covervid-video",
    staticStyle: {
      "position": "absolute",
      "top": "50%",
      "left": "50%",
      "transform": "translate(-50%, -50%)",
      "height": "auto",
      "width": "1860px"
    },
    attrs: {
      "id": "fullVideo"
    },
    on: {
      "timeupdate": _vm.progressBarVal
    }
  }, [_c('source', {
    attrs: {
      "src": "../media/160329_Rimowa_Topas_Loop_v2_2000.mp4",
      "type": "video/mp4"
    }
  })]), _vm._v(" "), _c('div', {
    class: ['controls', _vm.currentBoolean.isFullPlay ? 'active' : '']
  }, [_c('span', {
    staticClass: "btnPlay",
    on: {
      "click": _vm.toggleFullPlay
    }
  }, [_c('i', {
    class: [_vm.currentBoolean.toggleFullPlay ? 'icon-Play' : 'icon-Pause']
  })]), _vm._v(" "), _c('span', {
    staticClass: "volumen",
    on: {
      "click": _vm.toggleFullPlayMuted
    }
  }, [_c('i', {
    class: [_vm.currentBoolean.toggleFullPlayMuted ? 'icon-Sound_off' : 'icon-Sound_on']
  })]), _vm._v(" "), _c('span', {
    staticClass: "progressBar",
    attrs: {
      "id": "fullBar"
    },
    on: {
      "click": _vm.getProgressBar
    }
  }, [_c('span', {
    staticClass: "duration",
    style: (_vm.progressWidth)
  }, [_c('span', {
    staticClass: "currentTime"
  })]), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.pageText.time))])])])]), _vm._v(" "), _c('div', {
    staticClass: "mod-section-home content-container"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "video-btn-wrapper"
  }, [_c('div', {
    staticClass: "video-btn",
    on: {
      "click": _vm.canFullPlay
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "infoText anim"
  }, [_vm._v("\n        我是一个追求自由的人。财务自由，精神自由。虽然我现在只是一个伪全栈开发工程师，但是我相信未来肯定会更好。\n      ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "close"
  }, [_c('span'), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controls"
  }, [_c('span', {
    staticClass: "btnPlay"
  }, [_c('i', {
    staticClass: "icon-Pause"
  })]), _c('span', {
    staticClass: "volumen"
  }, [_c('i', {
    staticClass: "icon-Sound_on"
  })]), _c('span', {
    staticClass: "progressBar"
  }, [_c('span', {
    staticClass: "duration"
  }, [_c('span', {
    staticClass: "currentTime"
  })]), _c('span', {
    staticClass: "time"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "claim anim"
  }, [_c('span', {
    staticClass: "logo"
  }), _vm._v(" "), _c('p', [_vm._v("\n          保持饥饿，保持愚蠢\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('span', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', [_vm._v("欢迎来到吴伟的主页")])])]), _c('span', {
    staticClass: "second"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', {
    staticClass: "anim"
  }, [_vm._v("里面有你所需要的。")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d7d10b0!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/page/Home.vue
// module id = 242
// module chunks = 0